const emcr = require('./emcr');

const packs = [emcr];

const listPacks = () => packs;

const getPack = id => packs.find(pack => pack.id === id) || null;

// A form is generated only when the department has enabled it in
// settings/general.formPacks.{packId}.forms.{formId}.enabled (off by default).
const isFormEnabled = (settings, packId, formId) =>
    settings?.formPacks?.[packId]?.forms?.[formId]?.enabled === true;

module.exports = {
    listPacks,
    getPack,
    isFormEnabled
};
